import React from 'react';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Input from '@lightspeed/cirrus-input';
import FormField from 'cirrus/FormField';
import { moveCaretAtEnd } from 'helpers/utils';
import { createSanitizedMarkupForLocalize } from 'pages/utils/sanitize';

const BrandForm = ({
  handleSubmit,
  isSubmitting,
  isLoading,
  isDeleting,
  setFieldValue,
  values: { name },
  errors,
}) => (
  <form onSubmit={handleSubmit}>
    <FormField
      label="Brand Name"
      status={
        errors.name ? { type: 'error', message: createSanitizedMarkupForLocalize(errors.name) } : {}
      }
      className="cr-mb-2"
    >
      <Input
        name="name"
        value={name}
        maxLength="255"
        onFocus={moveCaretAtEnd}
        onChange={({ target: { value } = {} } = {}) => {
          setFieldValue('name', value);
        }}
        disabled={isLoading || isDeleting || isSubmitting}
        data-test="brand-name"
      />
    </FormField>
  </form>
);

const BrandsDetails = props => (
  <Card>
    <CardSection noSpacing>
      <div className="cr-p-4">
        <BrandForm {...props} />
      </div>
    </CardSection>
  </Card>
);

export default BrandsDetails;
